import { Component, input, model, ModelSignal } from "@angular/core";
import { NgClass } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectAllRowsDirective } from "../../directives";
import { InColumnPlacement } from "../../constants";

@Component({
  selector: "common-select-all-rows-cbx",
  standalone: true,
  imports: [NgClass, FormsModule, SelectAllRowsDirective],
  templateUrl: "./select-all-rows-cbx.component.html",
  styleUrl: "./select-all-rows-cbx.component.scss",
})
export class SelectAllRowsCbxComponent {
  readonly labelText = input("Alle");
  readonly placement = input<InColumnPlacement>("CENTER");
  readonly labelBold = input(true);
  readonly isAllSelected: ModelSignal<boolean> = model<boolean>(false);
}
